import { Component, Input } from '@angular/core';
import { Charts } from '../../models/report.model';

@Component({
    selector: 'app-summary-bar-chart',
    templateUrl: './summary-bar-chart.component.html',
    styleUrl: './summary-bar-chart.component.scss',
    standalone: false
})
export class SummaryBarChartComponent {
    @Input() charts: Charts;

    formatExactValue = (e: any) => {
        return e.value.toString();
    };
}
